import { Droplets, Milk, Pause, Pencil, Play } from 'lucide-react';
import { formatCurrency } from '../../data/mockData';
import { DELIVERY_FEE_MODES, PACK_KINDS } from '../../api/subscriptions';
import styles from './Subscriptions.module.css';

const KIND_ICON = {
  milk: Milk,
  water: Droplets,
  curd: Milk,
};

const FEE_LABEL = Object.fromEntries(DELIVERY_FEE_MODES.map((m) => [m.value, m.label]));
const KIND_LABEL = Object.fromEntries(PACK_KINDS.map((k) => [k.value, k.label]));

export default function PackCard({ pack, onEdit, onToggle, toggling }) {
  const Icon = KIND_ICON[pack.kind] || Milk;
  const feeMode = FEE_LABEL[pack.deliveryFeeMode] || pack.deliveryFeeMode;
  const discount = pack.discountPercent > 0 ? ` · ${pack.discountPercent}% off` : '';

  return (
    <div className={styles.packCard}>
      <div className={styles.packHead}>
        <span className={styles.packIcon}><Icon size={16} /></span>
        <div className={styles.packHeadText}>
          <p className={styles.packName}>{pack.name}</p>
          <p className={styles.packMeta}>
            {KIND_LABEL[pack.kind] || pack.kind}
            {' · '}
            {formatCurrency(pack.price)}
            {discount}
          </p>
        </div>
        <span
          className={`${styles.statusChip} ${
            pack.status === 'ACTIVE' ? styles.statusActive : styles.statusInactive
          }`}
        >
          {pack.status}
        </span>
      </div>

      <div className={styles.packBody}>
        <p className={styles.packDetail}>
          Qty/drop {pack.qtyPerDrop}
          {' · '}
          Fee {formatCurrency(pack.deliveryFee)} ({feeMode})
        </p>
        <p className={styles.packDetail}>
          Days: {(pack.daysOfWeekDefault || []).map((d) => d.slice(0, 1).toUpperCase() + d.slice(1, 3)).join(', ') || '—'}
        </p>
        {pack.description && <p className={styles.packDesc}>{pack.description}</p>}

        <div className={styles.packActions}>
          <button type="button" className={styles.packBtn} onClick={() => onEdit(pack)}>
            <Pencil size={13} /> Edit
          </button>
          {(pack.status === 'ACTIVE' || pack.status === 'INACTIVE') && (
            <button
              type="button"
              className={styles.packBtn}
              onClick={() => onToggle(pack)}
              disabled={toggling}
            >
              {toggling
                ? '…'
                : pack.status === 'ACTIVE'
                  ? <><Pause size={13} /> Deactivate</>
                  : <><Play size={13} /> Activate</>}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
